import { PageHero } from '@/components/site/PageHero'
import { createFileRoute, Link } from '@tanstack/react-router'
import { localServices } from '@/data/local-services'
import { posts } from './aktuelles'

export const Route = createFileRoute('/sitemap')({
  head: () => ({
    meta: [
      { title: 'Sitemap – Schober Transportservice' },
      {
        name: 'description',
        content:
          'Übersicht aller Seiten: Leistungen (Umzug, Entrümpelung, Transport, Büroumzug, Firmenumzug, Messie-Wohnung, Wohnungsauflösung), Aktuelles-Beiträge, Kontakt, FAQ und Unternehmensinfos von Schober Transportservice.',
      },
      { property: 'og:title', content: 'Sitemap – Schober Transportservice' },
      { property: 'og:description', content: 'Alle Seiten unserer Website im Überblick.' },
    ],
    links: [{ rel: 'canonical', href: 'https://schober-transportservice.at/sitemap' }],
  }),
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <>
      <PageHero title="SITEMAP" subtitle="Übersicht bewahren" />
      <section className="container mx-auto max-w-7xl px-4 py-20">
        <div className="space-y-10 text-muted-foreground">
          <div>
            <h1 className="text-[3rem] font-black text-brand-orange">Sitemap</h1>
            <p className="mt-4 max-w-3xl">
              Auf dieser Seite finden Sie eine strukturierte Übersicht aller Inhalte von
              Schober Transportservice. Wir sind Ihr Partner für Umzug, Entrümpelung,
              Wohnungsauflösung, Büroumzug und Transporte in Wien, Niederösterreich,
              Burgenland und der gesamten Ostregion Österreichs. Nutzen Sie die folgenden
              Links, um direkt zu den gewünschten Themen zu gelangen.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-brand-navy">Hauptseiten</h2>
            <ul className="mt-4 list-disc pl-6 space-y-1">
              <li><Link to="/" className="hover:text-brand-orange">Startseite – Schober Transportservice</Link></li>
              <li><Link to="/leistungen" className="hover:text-brand-orange">Leistungen – alle Services im Überblick</Link></li>
              <li><Link to="/ueber-uns" className="hover:text-brand-orange">Über uns – Unternehmen & Team</Link></li>
              <li><Link to="/aktuelles" className="hover:text-brand-orange">Aktuelles – Ratgeber, Tipps & News</Link></li>
              <li><Link to="/faq" className="hover:text-brand-orange">FAQ – häufige Fragen zu Umzug & Entrümpelung</Link></li>
              <li><Link to="/kontakt" className="hover:text-brand-orange">Kontakt – Anfrage & Angebot</Link></li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-brand-navy">Leistungen im Detail</h2>
            <p className="mt-2 max-w-3xl text-sm">
              Jeder Service ist als eigene Seite mit Ablauf, Preisen, FAQ und Beispielen
              dokumentiert. Zusätzlich gibt es lokale Unterseiten für die einzelnen Orte
              in Wien, Niederösterreich und Burgenland.
            </p>
            <ul className="mt-4 list-disc pl-6 space-y-1">
              {localServices.map((s) => (
                <li key={s.slug}>
                  <Link
                    to="/leistungen/$service"
                    params={{ service: s.slug }}
                    className="hover:text-brand-orange"
                  >
                    {s.titleLong}
                  </Link>{' '}
                  – {s.shortDescription}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-brand-navy">Aktuelles & Ratgeber</h2>
            <p className="mt-2 max-w-3xl text-sm">
              Unser Blog mit Praxiswissen zu Umzug in Wien, Entrümpelung, Halteverbot,
              Wohnungsauflösung, Messie-Räumung und Preisen 2026.
            </p>
            <ul className="mt-4 list-disc pl-6 space-y-1">
              {posts
                .filter((p) => !p.noindex)
                .map((p) => (
                  <li key={p.url}>
                    <Link to={p.url} className="hover:text-brand-orange">
                      {p.title}
                    </Link>
                  </li>
                ))}
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-brand-navy">Rechtliches</h2>
            <ul className="mt-4 list-disc pl-6 space-y-1">
              <li><Link to="/impressum" className="hover:text-brand-orange">Impressum</Link></li>
              <li><Link to="/datenschutz" className="hover:text-brand-orange">Datenschutz</Link></li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-brand-navy">XML-Sitemap für Suchmaschinen</h2>
            <p className="mt-2 max-w-3xl text-sm">
              Für Google, Bing und KI-Crawler steht zusätzlich eine maschinenlesbare
              Sitemap unter{' '}
              <a
                href="/sitemap.xml"
                className="text-brand-orange hover:underline"
              >
                /sitemap.xml
              </a>{' '}
              zur Verfügung. Dort finden Sie alle indexierbaren URLs inklusive lokaler
              Service-Seiten für Städte und Wiener Bezirke.
            </p>
          </div>
        </div>
      </section>
      <section className="container-fluid mx-auto px-4 border-b-20 border-brand-navy">
        &nbsp;
      </section>
    </>
  )
}
